import { usePlayerData } from "../usePlayerData";
import { CenterBigButtons } from "../SubPageLayout";
import { BigButtons } from "./BigButtons";
import { defineButton, DynamicBigButton } from "./DynamicBigButton";
import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";
import { BUTTONS } from "../buttons";

type UsePlayerLinksParams = {
	groupId: string;
	groupName?: string;
	categoryId?: string;
	subCategoryId?: string;
	subCategoryPaths?: string[];
}

export const usePlayerLinks = ({ groupId, groupName, categoryId, subCategoryId, subCategoryPaths }: UsePlayerLinksParams) => {
	const playerData = usePlayerData();
	const list = playerData.queryLinks({ groupId, groupName, categoryId, subCategoryId, subCategoryPaths });

	const isGatingCategory = categoryId;
	const isGatingGroup = groupId || groupName;
	const isGatingSubCategory = subCategoryId;

	const continueButton = useMemo(() => {
		const group = playerData.queryGroupBy({ id: groupId, name: groupName });
		const category = playerData.queryCategoryBy({
			groupId,
			groupName,
			categoryId,
		});
		const subCategory = playerData.querySubCategoryBy({
			groupId,
			groupName,
			categoryId,
			subCategoryId
		});

		if (subCategoryId && subCategory) {
			return defineButton({
				label: subCategory.name,
				navigateTo: subCategory.id,
			});
		}

		if (isGatingCategory && category) {
			return defineButton({
				label: category.name,
				backgroundUrl: category.bgImage.url,
				navigateTo: category.id,
			});
		}

		if (isGatingGroup && group) {

			if (group.name === "condor_news") {
				return BUTTONS.ZONTA_NEWS;
			}

			if (group.name === "instituto_joanir_zonta") {
				return BUTTONS.INSTITUTO_JOANIR_ZONTA;
			}

			if (group.name === "universidade_corporativa") {
				return BUTTONS.UNIVERSIDADE_CORPORATIVA;
			}

			if (group.name === "treinamento") {
				return BUTTONS.UNIVERSIDADE_CORPORATIVA;
			}

			if (group.name === "recrutamento_e_selecao") {
				return BUTTONS.RECRUTAMENTO_E_SELECAO;
			}

			if (group.name === "aovivo") {
				return BUTTONS.AO_VIVO;
			}

			if (group.name === "uc_online") {
				return BUTTONS.UC_ONLINE;
			}

		}

		return defineButton({
			label: "Continuar",
		});
	}, [isGatingCategory, isGatingGroup, isGatingSubCategory, categoryId, groupId, groupName, subCategoryId])

	return {
		list,
		isThereLinks: list.length > 0,
		continueButton,
	}
}

export const LinksListFetcher = (props: {
	groupId: string;
	groupName?: string;
	categoryId?: string;
	subCategoryId?: string;
	subCategoryPaths?: string[];
	suffix?: React.ReactNode;
}) => {
	const links = usePlayerLinks({ 
		groupId: props.groupId, 
		groupName: props.groupName, 
		categoryId: props.categoryId, 
		subCategoryId: props.subCategoryId,
		subCategoryPaths: props.subCategoryPaths
	});

	return <BigButtons
		buttons={links.list?.map((link) => {
			const imageUrl = link.image?.url;
			return defineButton({
				label: link.label,
				href: link.url,
				target: "_blank",
				backgroundUrl: imageUrl,
			});
		})}
		suffix={props.suffix}
	/>
};

export const LinksPromptWrapper = (props: {
	groupId: string;
	groupName?: string;
  categoryId?: string;
	subCategoryId?: string;
	subCategoryPaths?: string[];
	children?: React.ReactNode;
}) => {

	const [searchParams, setSearchParams] = useSearchParams();
	const links = usePlayerLinks({ 
		groupId: props.groupId, 
		groupName: props.groupName, 
		categoryId: props.categoryId,
		subCategoryId: props.subCategoryId,
		subCategoryPaths: props.subCategoryPaths
	});

	const hasSelectedContinueButton = searchParams.get("continue");

	const handleContinue = () => {
		setSearchParams({ continue: "true" });
	}

	if (!hasSelectedContinueButton && links.isThereLinks) {
		return <CenterBigButtons>
			<LinksListFetcher
				groupId={props.groupId}
				groupName={props.groupName}
				categoryId={props.categoryId}
				subCategoryId={props.subCategoryId}
				subCategoryPaths={props.subCategoryPaths}
				suffix={<DynamicBigButton 
					{...links.continueButton} 
					// Important: this is to just use the same button style and not 
					// to be redirected to the page again
					navigateTo={undefined}
					href={undefined}
					target={undefined}
					onClick={handleContinue} 
					backgroundUrl={links.continueButton.backgroundUrl}
				/>}
			/>
		</CenterBigButtons>
	}

	return props.children
};